@if (isOpen) {
	<div class="modal-backdrop fade show"></div>
	<div class="modal fade show d-block pwa-modal" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="pwa-install-title" (click)="later()">
		<div class="modal-dialog modal-dialog-centered" (click)="$event.stopPropagation()">
			<div class="modal-content border-0 pwa-card">
				<div class="modal-body p-4 text-center">
					<img class="pwa-logo mb-3" src="assets/icons/icon-192x192.png" alt="" width="72" height="72" />
					<h5 id="pwa-install-title" class="mb-2">Installer l'application MIF</h5>
					<p class="text-muted mb-3">Ajoutez MIF à votre écran d'accueil et ouvrez-la en un clic, comme n'importe quelle application.</p>

					@if (mode === "ios") {
						<ol class="pwa-list pwa-steps list-unstyled text-start mb-4">
							<li>
								<span class="pwa-step">1</span>
								<span>Appuyez sur le bouton <strong>Partager</strong> <i class="ri-upload-2-line align-middle"></i> de votre navigateur</span>
							</li>
							<li>
								<span class="pwa-step">2</span>
								<span>Choisissez <strong>« Sur l'écran d'accueil »</strong> <i class="ri-add-box-line align-middle"></i></span>
							</li>
							<li>
								<span class="pwa-step">3</span>
								<span>Validez avec <strong>Ajouter</strong></span>
							</li>
						</ol>
					} @else {
						<ul class="pwa-list pwa-benefits list-unstyled text-start mb-4">
							<li><i class="ri-home-smile-line"></i>Accès direct depuis votre écran d'accueil</li>
							<li><i class="ri-fullscreen-line"></i>Affichage plein écran, sans barre du navigateur</li>
							<li><i class="ri-flashlight-line"></i>Ouverture plus rapide</li>
						</ul>
					}

					<div class="d-grid gap-2">
						@if (mode === "ios") {
							<button #primaryBtn type="button" class="btn btn-primary rounded-pill shadow-none" (click)="later()">J'ai compris</button>
						} @else {
							<button #primaryBtn type="button" class="btn btn-primary rounded-pill shadow-none" (click)="install()">
								<i class="ri-download-2-line align-middle me-1"></i>Installer
							</button>
							<button type="button" class="btn btn-light rounded-pill shadow-none" (click)="later()">Plus tard</button>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
}
